
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Chess Tournament  </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2> Fide Chess <span>Competition</span></h2>
        </div>
        <div class="row">
            <div class="col-md-8">
                <div class="widget_title inner-title mt-3">
                    <h4>FIDE CHESS COMPETITION </h4>
                </div>
                <div class="fide-chess-text">
                    <p>16th GH Raisoni Memorial International Rating Nagpur Chess Festival was Inaugurated by the hands
                        Shri. Anurag Jain(IPS) DCP Nagpur, Shri Girish Vyas Ex MLC, Vice President MCA, Dr. Vivek Kapur
                        (Director) Raisoni Group, Shri Amit Gandhare Director (PRO) Raisoni Group, Shri S S Soman,
                        Working President Chess Association Nagpur, Shri. Bhushan Shriwas (Secretary) KPWF & CAN and
                        Shri Ajinkya Pingale Chief Arbiter.</p>
                </div>

            </div>
            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/summer-camp4.webp"
                        alt="GHRSCF" />

                </div>
            </div>
        </div>
        <div class="row  row-cols-1 row-cols-lg-3 mt-5">
            <div class="col">
                <div class="feature-area">
                    <div class="feature-wrap">
                        <div class="single-feature">
                            <div class="title text-center">
                                <h3 class="fs-4 lh-base">Fide Chess Competition 2024<i class="fa fa-arrow-right blink"
                                        aria-hidden="true"></i></h3>
                            </div>
                            <a routerLink="/fide-chess-amt" class="cmn-button">
                                Read More
                            </a>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col">
                <div class="feature-area">
                    <div class="feature-wrap">
                        <div class="single-feature">
                            <div class="title text-center">
                                <h3 class="fs-4 lh-base">Women's Chess Championship<i class="fa fa-arrow-right blink"
                                        aria-hidden="true"></i></h3>
                            </div>
                            <a routerLink="/chess-championship" class="cmn-button">
                                Read More
                            </a>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col">
                <div class="feature-area">
                    <div class="feature-wrap">
                        <div class="single-feature">
                            <div class="title text-center">
                                <h3>Fide Chess Competition 2023<i class="fa fa-arrow-right blink"
                                        aria-hidden="true"></i></h3>
                            </div>
                            <a routerLink="/fide-chess2023" class="cmn-button">
                                Read More
                            </a>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col">
                <div class="feature-area">
                    <div class="feature-wrap">
                        <div class="single-feature">
                            <div class="title text-center">
                                <h3>Fide Chess Competition 2021<i class="fa fa-arrow-right blink"
                                        aria-hidden="true"></i></h3>
                            </div>
                            <a routerLink="/fide-chess2023" class="cmn-button">
                                Read More
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="feature-area">
                    <div class="feature-wrap">
                        <div class="single-feature">
                            <div class="title text-center">
                                <h3>Fide Chess Competition 2020<i class="fa fa-arrow-right blink"
                                        aria-hidden="true"></i></h3>
                            </div>
                            <a routerLink="/javascript:void(0);" class="cmn-button">
                                Read More
                            </a>
                        </div>
                    </div>
                </div>

            </div>
            <div class="col">
                <div class="feature-area">
                    <div class="feature-wrap">
                        <div class="single-feature">
                            <div class="title text-center">
                                <h3>Fide Chess Competition 2019<i class="fa fa-arrow-right blink"
                                        aria-hidden="true"></i></h3>
                            </div>
                            <a routerLink="/fide-chess2019" class="cmn-button">
                                Read More
                            </a>
                        </div>
                    </div>
                </div>

            </div>
            <div class="col">
                <div class="feature-area">
                    <div class="feature-wrap">
                        <div class="single-feature">
                            <div class="title text-center">
                                <h3>Fide Chess Competition 2018<i class="fa fa-arrow-right blink"
                                        aria-hidden="true"></i></h3>
                            </div>
                            <a routerLink="/fide-chess2018" class="cmn-button">
                                Read More
                            </a>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>
